export default {
    methods: {
        checkout_config_getFields(config, {tags}) {

            tags = "undefined" === typeof tags ? [] : tags;

            return config
                .filter(field => undefined === field.tags || 0 < field.tags.filter(fieldTag => -1 !== tags.indexOf(fieldTag)).length)
                .map(field => {

                    if (field.validation) {

                        if (undefined === field.errors) {

                            field.errors = {}
                        }

                        Object.keys(field.validation).forEach(key => {

                            if (this.$te(`checkout_config.${field.payload.field}.errors.${key}`)) {

                                field.errors[key] = this.$t(`checkout_config.${field.payload.field}.errors.${key}`)
                            }
                        })
                    }

                    return field;
                });
        }
    }
}